import React, { useState } from 'react';

import GiveKudosLauncher from '@atlaskit/give-kudos/give-kudos-launcher/main';

import { getConfig } from '@townsquare/config';
import { useFlagActions } from '@townsquare/flags';
import { useWorkspaceStore } from '@townsquare/workspace-store';

interface useKudosLauncherProps {
	analyticsSource?: string;
}
const config = getConfig();

export const useKudosLauncher = (
	props: useKudosLauncherProps,
): {
	openKudosLauncher: () => void;
	kudosLauncher: React.JSX.Element;
} => {
	const [isGiveKudosOpen, setIsGiveKudosOpen] = useState(false);
	const { addFlag } = useFlagActions();
	const [workspace] = useWorkspaceStore();
	const openKudosLauncher = (): void => {
		setIsGiveKudosOpen(true);
	};

	const kudosLauncher = (
		<GiveKudosLauncher
			isOpen={isGiveKudosOpen}
			onClose={() => setIsGiveKudosOpen(false)}
			analyticsSource={props.analyticsSource || 'atlas'}
			teamCentralBaseUrl={config.fullUrl}
			cloudId={workspace.cloudId || ''}
			addFlag={addFlag}
		/>
	);

	return {
		openKudosLauncher,
		kudosLauncher,
	};
};
